<template>
  <div id="app">
    <router-view/>
  </div>
  
</template>

<script>
export default {
  name: "app"
};
</script>

<!--<style>
    @import './static/css/vtreld.css'
</style>-->

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue